function handleCloseLightBoxClickOutside(e) {
  const clickedPopup = e.target.closest('.gdc-gallery-posts-grid-lightbox')
  const clickedSliderButton = e.target.closest('.gdc-gallery-posts-grid-lightbox__btn')

  if (!clickedPopup && !clickedSliderButton) {
    handlePostsLightboxClose(e)
  }
}

function handlePostsLightbox(e) {
  const _s = {
    lightboxID: e.currentTarget.dataset.block,
  }

  const _m = {
    init() {
      _m.openLightbox()
      _m.lockPageScrollLightBox()
      window.addEventListener('click', handleCloseLightBoxClickOutside)
    },

    lightbox() {
      return document.querySelector(`[data-lightbox="${_s.lightboxID}"]`)
    },

    imageGrid() {
      return _m.lightbox().querySelector(`.gdc-gallery-posts-grid-lightbox__image-grid`)
    },

    articleContent() {
      return _m.lightbox().querySelector(`.gdc-gallery-posts-grid-lightbox__article-content-text`)
    },

    openLightbox() {
      _m.lightbox().classList.remove('gdc-hide-posts-lightbox')
    },

    lockPageScrollLightBox() {
      document.querySelector('body').style.overflow = 'hidden'
    },
  }
  _m.init()
}

function handlePostsLightboxClose(e) {
  const lightBox = e.target.closest('.gdc-gallery-posts-grid-lightbox__wrapper')

  if (lightBox) {
    document.querySelector('body').style.overflow = 'auto'
    lightBox.classList.add('gdc-hide-posts-lightbox')
    window.removeEventListener('click', handleCloseLightBoxClickOutside)
  }
}

function formatLightboxes() {
  const _m = {
    lightboxes() {
      return document.querySelectorAll(`.gdc-js-posts-grid-lightbox`)
    },

    imageGrid(elem) {
      return elem.querySelector(`.gdc-gallery-posts-grid-lightbox__image-grid`)
    },

    articleContent(elem) {
      return elem.querySelector(`.gdc-gallery-posts-grid-lightbox__article-content-text`)
    },

    getContentImages(elem) {
      return elem.querySelectorAll('img')
    },

    removeAllVideos(elem) {
      // Remove videos from content because causing loading errors on mobile on dev theme
      // Can test again after theme is live to see if issue resolves
      const videos = elem.querySelectorAll('iframe')

      videos.forEach((video) => {
        video.remove()
      })
    },

    moveAllImagesToImageGrid(imgArray, grid) {
      imgArray.forEach((img) => {
        let cloneImage = img.cloneNode()

        // remove inline styles from Shopify article editor
        cloneImage.removeAttribute('style')
        cloneImage.removeAttribute('height')
        cloneImage.removeAttribute('width')

        cloneImage && grid.appendChild(cloneImage)
      })
    },

    removeOriginalContent(elem) {
      _m.articleContent(elem).remove()
    },

    formatLightBox() {
      _m.lightboxes().forEach((lightbox) => {
        _m.moveAllImagesToImageGrid(
          _m.getContentImages(_m.articleContent(lightbox)),
          _m.imageGrid(lightbox)
        )
        _m.removeAllVideos(lightbox)
        // _m.handleNoTextContent(lightbox)
        _m.removeOriginalContent(lightbox)
      })
    },
  }

  _m.formatLightBox()
}

function handlePostsSliderButton(e) {
  const direction = e.target.dataset.direction
  const gallery = e.target.closest('.gdc-gallery-posts-grid-lightbox__wrapper')
  const galleryId = gallery.dataset.sectionId
  const slides = document.querySelectorAll(
    `.gdc-js-posts-grid-lightbox[data-section-id="${galleryId}"]`
  )
  const currentSlide = [...slides].filter(
    (slide) => !slide.classList.contains('gdc-hide-posts-lightbox')
  )
  const currentSlideIndex = currentSlide[0].dataset.gridIndex - 1
  const nextSlide = currentSlideIndex + 1
  const prevSlide = currentSlideIndex - 1
  const firstSlide = 0
  const lastSlide = slides.length - 1

  const hideAllSlides = () =>
    slides.forEach((slide) => slide.classList.add('gdc-hide-posts-lightbox'))
  const handleDirection = () => (direction === 'forward' ? handleForward() : handleBack())
  const showSlide = (index) => slides[index].classList.remove('gdc-hide-posts-lightbox')

  const handleForward = () => (slides[nextSlide] ? showSlide(nextSlide) : showSlide(firstSlide))

  const handleBack = () =>
    currentSlideIndex === firstSlide ? showSlide(lastSlide) : showSlide(prevSlide)

  hideAllSlides()
  handleDirection()
}

window.addEventListener('DOMContentLoaded', formatLightboxes)
